<script setup lang="ts">
import ModalAddVoice from '@/components/domains/admin/common/ModalAddVoice.vue';
</script>

<template>
  <ModalAddVoice></ModalAddVoice>
</template>

<style lang="scss" scoped> </style>
